import {Brand} from '../Brand';
import {sextingAnonymousBase} from './sextingAnonymousBase';
import {SextingAnonymousLogo} from './SextingAnonymousLogo';

export const sextingAnonymous: Brand = {
  ...sextingAnonymousBase,
  assets: {
    logo: SextingAnonymousLogo,
  },
};
